import { SxProps, Theme } from "@mui/material/styles";

export const pageContainer: SxProps<Theme> = {
    width: {
        xs: "100%",
        md: "50%",
    },
    mx: "auto",
};

export const contentContainer: SxProps<Theme> = {
    px: 4,
    minHeight: "60vh",
    wordBreak: "break-word",
};

export const pageTitle: SxProps<Theme> = {
    fontSize: {
        xs: "1.8rem",
        md: "2.5rem",
    },
    fontWeight: "bold",
    color: (theme: Theme) => theme.palette.white,
    mb: 4,
};

export const section: SxProps<Theme> = {
    mb: 4,
};

export const sectionTitle: SxProps<Theme> = {
    fontSize: {
        xs: "1.4rem",
        md: "1.8rem",
    },
    fontWeight: "600",
    color: (theme: Theme) => theme.palette.white,
    mb: 2,
};

export const paragraph: SxProps<Theme> = {
    lineHeight: 1.6,
    mb: 2,
    color: (theme: Theme) => theme.palette.white,
};
